import React from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import DatasourceBaseTextFields from "../Datasources/DatasourceBaseTextFields.jsx";

const DatasourceTopdesk = (props) => {

    const Fields = [
        {Identifier:"Url", Translation:"URL", Required:true},
        {Identifier:"UserName", Translation:Translate("Username"), Required:true},
        {Identifier:"ApplicationToken", Translation:Translate("Application token"), Required:true, PasswordField:true}
    ]
    
    return (<DatasourceBaseTextFields SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} Fields={Fields} OnSetReady={props.OnSetReady}/>)

}

DatasourceTopdesk.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceTopdesk